export default {
  shortOpinionsList:
    localStorage
      .getItem("filterStatus.shortOpinionsList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || [],
  goaesList:
    localStorage
      .getItem("filterStatus.goaesList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || [],
  secondOpinionsList:
    localStorage
      .getItem("filterStatus.secondOpinionsList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || [],
  shortOpinionOverviewList:
    localStorage
      .getItem("filterStatus.shortOpinionOverviewList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || [],
  goaesOverviewList:
    localStorage
      .getItem("filterStatus.goaesOverviewList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || [],
  secondOpinionOverviewList:
    localStorage
      .getItem("filterStatus.secondOpinionOverviewList")
      ?.split(",")
      .filter((e) => e.trim() !== "") || []
}
